import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { BrowserRouter as Router } from 'react-router-dom';

import store from './store';
import App from './App';
import GlobalStyle from './style';
import 'flag-icon-css/css/flag-icon.min.css';

import { version, name } from '../package.json';
import { API_URL } from './config/constants';
import './config/initialize';

console.log(`${name}@${version}`);
console.log('API URL:', API_URL);

const Index = () => {
	return (
		<Provider store={store}>
			<Router>
				<GlobalStyle />
				<App />
			</Router>
		</Provider>
	);
};

ReactDOM.render(<Index />, document.getElementById('root'));
